import { Button } from '@popsure/dirty-swan';
import { useSafeTranslation } from 'shared/i18n';

import styles from './Confirm.module.scss';

type ConfirmViewProps = {
  email?: string;
  onUpdateEmail: () => void;
  isLoading: boolean;
};

export const ConfirmView = ({
  email,
  onUpdateEmail,
  isLoading,
}: ConfirmViewProps) => {
  const { t } = useSafeTranslation();

  return (
    <div className={styles.container}>
      <div className="p-body">
        <h1 className="p-h1">
          {t(
            'updateEmail.updateConfirmation.title',
            'Confirm the email change'
          )}
        </h1>
        <div className="p-p mt8">
          {t(
            'updateEmail.updateConfirmation.subtitle',
            'Your new email address will be'
          )}{' '}
          <span className="fw-bold">{email}</span>
        </div>
        <Button
          className="wmn3 mt16"
          onClick={onUpdateEmail}
          loading={isLoading}
          disabled={isLoading}
        >
          {t(
            'updateEmail.updateConfirmation.button.text',
            'Yes, change my email'
          )}
        </Button>
      </div>
    </div>
  );
};
